import { ClipboardListIcon, EyeIcon, FolderIcon } from "lucide-react";
import * as React from "react";
import { useGetFavoritesQuery } from "@/api/files";
import { useGetSnapshotCollectionFavoritesQuery } from "@/modules/snapshots/snapshotCollection.api";
import { buildSnapshotGridPath } from "@/modules/snapshots/routes";
import { SidebarIconItem } from "./SidebarIconItem";
import { useGetSnapshotViewFavoritesQuery } from "@/modules/snapshots/snapshotViews.api";

export const SidebarFavoriteIcons: React.FC = () => {
  const { data: favorites = [] } = useGetFavoritesQuery();
  const { data: snapshotCollectionFavorites = [] } = useGetSnapshotCollectionFavoritesQuery();
  const { data: snapshotViews = [] } = useGetSnapshotViewFavoritesQuery();

  const hasFavorites = favorites.length > 0 || snapshotCollectionFavorites.length > 0 || snapshotViews.length > 0;

  if (!hasFavorites) {
    return null;
  }

  return (
    <>
      <div className="my-2 w-6 border-t border-gray-400" />

      {/* File/Folder Favorites */}
      {favorites.map(favorite => (
        <SidebarIconItem
          key={favorite.id}
          href={`/drive/${favorite.fs_entry_id}`}
          tooltip={favorite.folder_name}
          icon={FolderIcon}
        />
      ))}

      {/* Snapshot Collection Favorites */}
      {snapshotCollectionFavorites.map(favorite => (
        <SidebarIconItem
          key={`snapshot-${favorite.id}`}
          href={buildSnapshotGridPath(favorite.business_report_id, favorite.snapshot_collection_id)}
          tooltip={favorite.name}
          icon={ClipboardListIcon}
        />
      ))}
      {snapshotViews.map(view => (
        <SidebarIconItem
          key={`view-${view.id}`}
          href={`/snapshots/views/${view.id}`}
          tooltip={view.name}
          icon={EyeIcon}
        />
      ))}
    </>
  );
};
